import React, { useState } from 'react';
import { MainDialog, MainDialogProps } from '@components/dialog/main.dialog';
import { MainDialogTitle } from '@components/dialog/main.dialog.title';
import { CreditsFormProps } from '@screens/players/player.actions/credits/types/credits.form.props';
import { PlayerData } from '@domain/types/player/player.data';
import { MainDialogContent } from '@components/dialog/main.dialog.content';
import { CenteredRoot, DescText } from '@styles/common';
import { Loading } from '@components/loading';
import { Button, DialogActions, FormControl, FormHelperText, InputLabel } from '@material-ui/core';
import { ErrorDisplay } from '@components/error/error.display';
import { NotesContainer, NotesInput } from '@screens/players/player.details.tabs/notes/notes.form.styles';
import { useAuth } from '@domain/auth/auth.hook';
import { CancelToken } from 'axios';
import { useFormData } from '@domain/hooks/use.form.data';
import MetricsComboBox from '@screens/players/player.actions/metrics/metrics.combo.list';

const categoryList = ['CRM', 'FAN PAGE', 'MODERATION', 'SUPPORT', 'OTHERS', 'RELEVANT'];

interface NoteDialogProps extends MainDialogProps {
  player: PlayerData;
}

interface NotesFormProps extends CreditsFormProps {
  player: PlayerData;
}

interface NoteFormData {
  pid?: number;
  moderator?: string;
  content?: string;
  category?: string;
}
const PlayerNoteInsert = (props: NoteDialogProps) => {
  const { open } = props;
  const { player } = props;
  return (
    <MainDialog {...props}>
      <MainDialogTitle icon='insert-comment'>Insert Note</MainDialogTitle>
      <NotesInsertContent onFinish={open.disable} player={player} />
    </MainDialog>
  );
};

const NotesInsertContent = ({ player, onFinish }: NotesFormProps) => {
  const { authorizedServices, user } = useAuth();
  const { pid } = player;
  const moderator = user?.username;

  const [category, setCategory] = useState('');

  async function sendNote(data: NoteFormData, cancelToken: CancelToken | undefined) {
    if (cancelToken) cancelToken.throwIfRequested();
    return authorizedServices
      .post('/admin/box-note/save', { pid: data.pid, moderator: data.moderator, category, content: data.content, cancelToken })
      .then(onFinish);
  }

  const formData = useFormData({ pid, moderator }, sendNote);

  const { data, loading, error, validationErrors, submit, handleChange } = formData;

  return (
    <>
      <MainDialogContent>
        <Loading loading={loading} />
        <fieldset disabled={loading}>
          <CenteredRoot>
            <DescText>Insert a note for the player</DescText>
          </CenteredRoot>
          <MetricsComboBox onChange={setCategory} comboLabel='Category' />

          <NotesContainer>
            <FormControl>
              <InputLabel id='content'>Note:</InputLabel>
              <NotesInput id='content' name='content' fullWidth onChange={handleChange} multiline />
              <FormHelperText error>{validationErrors}</FormHelperText>
            </FormControl>
          </NotesContainer>
        </fieldset>

        <ErrorDisplay error={error} />
      </MainDialogContent>

      <DialogActions>
        <Button onClick={submit} color='primary' disabled={loading}>
          Send
        </Button>
      </DialogActions>
    </>
  );
};

export default PlayerNoteInsert;
